exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".caption{text-align:center;font-style:italic}.caption_title{font-size:18px}.caption_description{font-size:13px}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AACA,SACE,iBAAA,CACA,iBAAA,CAEA,eACE,cAAA,CAEF,qBACE,cAAA","file":"styles.scss","sourcesContent":["$theme: zam;\n.caption {\n  text-align: center;\n  font-style: italic;\n\n  &_title {\n    font-size: 18px;\n  }\n  &_description {\n    font-size: 13px;\n  }\n}\n"]}]);

// Exports
exports.locals = {
	"caption": "caption",
	"caption_title": "caption_title",
	"caption_description": "caption_description"
};